/**
 * Created by JaneCC on 2018-04-12.
 */
export const getPermission = (state, key) => {
    return key;
    // return _.indexOf(state.authList, key) !== -1;
};
